var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TimeRangePanel',{ref:"timeRangePanelRef",on:{"pick":_vm.handlePick}})
}
var staticRenderFns = []

export { render, staticRenderFns }